import { useEffect } from 'react';
import axios from 'axios';

/**
 * Refetch visions while any have image_status=pending (async cover generation).
 */
export function usePendingVisionImagePoll(visions, onVisionsUpdate, options = {}) {
  const { intervalMs = 3000, maxAttempts = 30 } = options;

  const pendingKey =
    visions
      ?.filter((v) => v?.image_status === 'pending' && !v?.image_url)
      .map((v) => v.vision_id)
      .join(',') || '';

  useEffect(() => {
    if (!pendingKey || typeof onVisionsUpdate !== 'function') return undefined;

    let attempts = 0;
    let cancelled = false;

    const tick = async () => {
      attempts += 1;
      try {
        const res = await axios.get('/api/visions', { timeout: 10000 });
        const list = res.data?.visions || [];
        if (!cancelled) onVisionsUpdate(list);
        const stillPending = list.some(
          (v) => v.image_status === 'pending' && !v.image_url
        );
        return !stillPending || attempts >= maxAttempts;
      } catch {
        return attempts >= maxAttempts;
      }
    };

    const id = setInterval(async () => {
      if (await tick()) clearInterval(id);
    }, intervalMs);

    tick();

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [pendingKey, onVisionsUpdate, intervalMs, maxAttempts]);
}
